/**
 * Joins truthy class names with a single space. Falsy values (`false`, `null`,
 * `undefined`, `''`) are dropped, so the common conditional idioms compose
 * cleanly:
 *
 *   cx(styles.base, className)                    // optional passthrough
 *   cx(styles.item, isActive && styles.active)    // conditional class
 */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
